export default {
  heroTitle1: 'Blog',
  heroTitle2: '& Artikler',
  heroSubtitle: 'Alt det vigtigste samlet ét sted. Læs om elbiler, ladning, elpriser og meget mere.',
  readyToSave: 'Klar til at spare på din el?',
  seeProducts: 'Se vores produkter og find den løsning der passer til dig',
  elPlan: 'El-aftale',
  chargerPlusEl: 'Ladeboks + El',
  haveQuestions: 'Har du spørgsmål?',
  seeFaqOrContact: 'Se vores FAQ eller kontakt os – vi er her for at hjælpe',
  seeFaq: 'Se FAQ',
  articlesTitle: 'Artikler fra Enkel Energi',
  articlesSubtitle: 'Læs vores guides og artikler om elbiler, ladeløsninger og smart energi',
  backToBlog: 'Tilbage til blog',
  seeAllArticles: 'Se alle artikler',
  videosTitle: 'Videoer',
  videosComingSoon: 'Videoindhold kommer snart',
  videosComingSoonFull: 'Videoer kommer snart',
  videosDescription: 'Vi arbejder på at skabe videoguides og tutorials om elbiler, ladeløsninger og smart energi. Hold øje med denne side for opdateringer!',
  chooseYourPlan: 'Vælg den aftale der passer til dig',
  allPlansNoBinding: 'Alle El-Aftaler uden binding. Skift når du vil.',

  // Blog article titles and excerpts
  articles: {
    taenkTest: {
      title: 'Tre enkel-produkter i top 10 i Forbrugerrådet Tænks eltest 2026',
      excerpt: 'Tre Enkel-produkter placerede sig i top 10 i Tænks eltest 2026. For elbilister kan den reelle pris være lavere end tabellen viser — her forklarer vi hvorfor.'
    },
    impactStudy: {
      title: 'Uafhængigt studie: Smart opladning kan spare Europa for 117 mio. ton CO₂ om året',
      excerpt: 'Et tysk forskningsinstitut har analyseret den systemiske effekt af smart opladning — med enkel energi som case. Resultat: Op til 117 mio. ton CO₂ sparet årligt, milliarder i besparelser og hurtigere elbil-adoption.'
    },
    ladekrig: {
      title: 'Ladekrig skifter gear: enkel energi betaler elbilejere for at lade hjemme',
      excerpt: 'Jyllands-Posten omtaler enkel energi som første danske aktør til at tilbyde elbilejere kontant gevinst ved hjemmeladning. FDM-ekspert kalder det en kæmpe nyhed.'
    },
    nicolaskj: {
      title: 'NicolasKJ.dk kårede Enkel Energi som billigst i sin test',
      excerpt: 'Uafhængig analyse fra NicolasKJ.dk placerede Enkel Energi i toppen af sammenligningen af variable elaftaler i Danmark – uden affiliatelinks. Resultatet gælder testens forudsætninger og tidspunkt.'
    },
    elbiilTest: {
      title: 'ELBIIL.dk-test: enkel energi kåret som billigste ladeløsning',
      excerpt: 'Uafhængig prissammenligning af 14 udbydere placerede enkel energi lavest på el og service til ladeboks. Resultatet gælder testens forudsætninger og tidspunkt.'
    },
    ladestandere: {
      title: 'Alt om ladestandere til hjemmet',
      excerpt: 'Elbiler er blevet en fast del af hverdagen, og flere vælger at få deres egen ladestander hjemme. Med en privat ladestander kan du lade bilen, når det passer dig.'
    },
    guideElLader: {
      title: 'Guide til el lader hjemme - sådan kommer du i gang',
      excerpt: 'At kunne lade elbilen hjemme gør hverdagen nemmere. Du slipper for at køre rundt efter en ledig stander og kan starte dagen med fuldt batteri.'
    },
    installationPris: {
      title: 'Hvad koster installation af ladeboks til elbil?',
      excerpt: 'Mange elbilejere vælger at få en ladeboks derhjemme. Det gør hverdagen nemmere, fordi bilen kan lades op, mens du sover eller laver andre ting.'
    },
    smartOpladning: {
      title: 'Smart opladning og netbalancering',
      excerpt: 'Elbiler spiller en større rolle i vores hverdag og i energisystemet. Med flere elbiler på vejene stiger behovet for at tænke smartere omkring opladning.'
    },
    refusion: {
      title: 'Sådan fungerer refusion af elafgift',
      excerpt: 'Elbiler er blevet en fast del af hverdagen for mange. En af de ting, der gør hjemmeladning ekstra attraktiv, er muligheden for refusion af elafgift.'
    },
    ladeboks: {
      title: 'Ladeboks til din elbil',
      excerpt: 'Hvis du har en elbil, er en ladeboks hjemme en af de bedste investeringer, du kan lave. Det giver dig frihed til at lade, når det passer dig.'
    },
    bedsteLadestandere: {
      title: 'De bedste ladestandere i 2025',
      excerpt: 'Elbiler fylder mere og mere på de danske veje, og det samme gør behovet for gode ladeløsninger. I 2025 er markedet for ladestandere vokset kraftigt.'
    },
    sammenligning: {
      title: 'Zaptec Go vs. Zaptec Go 2 vs. NexBlue Edge 2',
      excerpt: 'Når du skal vælge en ladeboks til din elbil, er det naturligt at kigge på de mest populære modeller. Her får du en grundig sammenligning.'
    },
    velkommen: {
      title: 'Velkommen til enkel energi – info ved tvunget leverandørskift',
      excerpt: 'Er du endt hos enkel energi efter et tvunget leverandørskift? Her finder du alt, du skal vide om din nye aftale, dine fordele og dine muligheder.'
    }
  }
};